<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center py-5">
        <b-col md="12" sm="12">
          <register-success v-if="confirmed" @reConfirm="markConfirmed" />
          <confirmation-form
            v-else
            :setEmail="email"
            :setCode="code"
            @onUserConfirmed="markConfirmed"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ConfirmationForm from '@/components/auth/register/ConfimationForm'
import RegisterSuccess from '@/components/auth/register/RegisterSuccess'

export default {
  name: 'Register',
  components: {
    RegisterSuccess,
    ConfirmationForm
  },
  data () {
    return {
      email: this.$route.query.email,
      code: this.$route.query.code,

      confirmed: false
    }
  },
  methods: {
    markConfirmed () {
      this.confirmed = true
      this.$bvToast.toast('You can now log in.', {
        title: 'Registration Successful',
        variant: 'success'
      })
    }
  }
}
</script>
